export default __webpack_public_path__ + "static/media/ROJI@3x.2b465073.png";